import React from 'react';
import { Space, Divider, Typography } from 'antd';
import { SettingOutlined } from '@ant-design/icons';

import { ComandosRapidos, ComandoPersonalizado, ModalRectificacion } from './Components';
import { useComandos } from './hooks/useComandos';
import { opcionesRectificacion } from './config/opcionesRectificacion';

const { Title } = Typography;

export const ComandosTab = () => {
  const {
    form,
    selectedRectificacion,
    modalRectificarVisible,
    argumento,
    limpiarCache,
    rectificar,
    customComando,
    onFinishComandoPersonalizado,
    handleRectificarClick,
    handleRectificarSubmit,
    handleModalCancel,
    handleSelectionChange,
    handleArgumentoChange
  } = useComandos();

  return (
    <div style={{ maxWidth: 700, margin: '0 auto' }}>
      <div style={{ textAlign: 'center', marginBottom: 28 }}>
        <SettingOutlined style={{ fontSize: 28, color: '#1890ff', marginBottom: 6, display: 'block' }} />
        <Title level={4} style={{ margin: 0 }}>Panel de Comandos</Title>
        <Typography.Text type="secondary" style={{ fontSize: 13 }}>
          Herramientas de administración y mantenimiento del sistema
        </Typography.Text>
      </div>

      <Space direction="vertical" style={{ width: '100%' }} size={24}>
        <ComandosRapidos
          limpiarCache={limpiarCache}
          onRectificarClick={handleRectificarClick}
          rectificarLoading={rectificar.isLoading}
        />

        <Divider style={{ margin: '0' }} />

        <ComandoPersonalizado
          form={form}
          onFinish={onFinishComandoPersonalizado}
          customComando={customComando}
        />
      </Space>

      <ModalRectificacion
        visible={modalRectificarVisible}
        onOk={handleRectificarSubmit}
        onCancel={handleModalCancel}
        loading={rectificar.isLoading}
        selectedRectificacion={selectedRectificacion}
        onSelectionChange={handleSelectionChange}
        opcionesRectificacion={opcionesRectificacion}
        argumento={argumento}
        onArgumentoChange={handleArgumentoChange}
      />
    </div>
  );
};

export default ComandosTab;
